/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
// import qs from 'qs'
import router from "@/router"
import { clearLoginInfo } from "@/httpRequest/utils"
axios.defaults.withCredentials = true

const http = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        // 'content-type': 'application/json; charset=utf-8',
        "Content-Type": "application/x-www-form-urlencoded"
    },
    transformRequest: [
        function(data) {
        // let ret = "";
        // if (data.length == 1) {
        //     for (let it in data) {
        //         ret +=
        //         encodeURIComponent(it) + '=' + encodeURIComponent(data[it]);
        //     }
        // } else {
        //     for (let it in data) {
        //         ret +=
        //         encodeURIComponent(it) + '=' + encodeURIComponent(data[it]);
        //     }
        // }
        
        return data;
        }
    ]
})
http.interceptors.response.use(
    response => {
      if (response.data && response.data.code === 202) {
        // 401, token失效
        clearLoginInfo()
        router.push({ path: '/login' });
      }
      return response;
    },
    error => {
      return Promise.reject(error);
    }
  );
/** 
 *   @param {*} actionName action方法名称 
*/
http.adornUrl = (actionName, who) =>{
    var actionArr = actionName.split('/')
    var tmpArr = []
    for (var i in actionArr) {
        if ((actionArr.length > 3 && i > 1) || (actionArr.length > 2 && i > 0)) {
        tmpArr.push(actionArr[i]);
        }
    }
    if (who == 'proxyBD'){
        return ((process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY
        ? '/proxyBD'
        : window.SITE_CONFIG.baseUrl)+
            "/webservice/background/index.jsp/v1/" +
            tmpArr.join("/") +
            "?token=dXNlcj1iYWNrZ3JvdW5kJnB3ZD15bDEwMDE="
        );
    }
    var proxyApi = ""
    if (who) {
        switch (who) {
            case 'proxyLS':
                proxyApi = '/proxyLS'
                break;
            default:
                break;
        }
    }
    return ((process.env.NODE_ENV !== "production" && process.env.OPEN_PROXY
    ? proxyApi
    : window.SITE_CONFIG.baseUrl)+
        "/webservice/question/index.jsp/v1/" +
        tmpArr.join("/") +
        "?token=dXNlcj13YW5nZ20mcHdkPXdhbmdnbTMyNg=="
    );
}
// 账户
http.accountUrl = (actionName, who) =>{
    var actionArr = actionName.split('/')
    var tmpArr = []
    for (var i in actionArr) {
        if ((actionArr.length > 3 && i > 1) || (actionArr.length > 2 && i > 0)) {
        tmpArr.push(actionArr[i]);
        }
    }
    var proxyApi = ""
    if (who) {
        switch (who) {
            case 'proxyCS':
                proxyApi = '/proxyCS';
                break;
            case 'proxyLS':
                proxyApi = '/proxyLS';
                break;
            default:
                break;
        }
    }
    // return ((process.env.NODE_ENV !== "production" && process.env.OPEN_PROXY
    // ? proxyApi
    // : window.SITE_CONFIG.baseUrl)+
    //     "/webservice/account/index.jsp/v1/" +
    //     tmpArr.join("/") +
    //     "?token=dXNlcj1hY2NvdW50JnB3ZD1hY2NvdW50MTIz"
    // );
    return ((process.env.NODE_ENV !== "production" && process.env.OPEN_PROXY
    ? proxyApi
    : window.SITE_CONFIG.baseUrl)+
        "/webservice/question/index.jsp/v1/" +
        tmpArr.join("/") +
        "?token=dXNlcj13YW5nZ20mcHdkPXdhbmdnbTMyNg=="
    );
}
/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
// http.adornParams = (params = {}, openDefultParams = true) => {
//     var defaults = {
//       // t: new Date().getTime()
//     };
//     return openDefultParams ? merge(defaults, params) : params;
//   };
  
  /**
   * post请求数据处理
   * @param {*} data 数据对象
   * @param {*} openDefultdata 是否开启默认数据?
   * @param {*} contentType 数据格式
   *  json: 'application/json; charset=utf-8'
   *  form: 'application/x-www-form-urlencoded; charset=utf-8'
   */
  http.adornData = (data = {}, openDefultdata = true, contentType = "json") => {
    var defaults = {
      // t: new Date().getTime()
    };
    data = openDefultdata ? data : data;
    // return contentType === "json" ? JSON.stringify(data) : qs.stringify(data);
  };
  
  export default http;


// WEBPACK FOOTER //
// ./src/httpRequest/index.js